import React, { useState } from "react";
import "./PrivacyPolicySection.css";
import Navbar from "../../components/Navbar/Navbar";
import fraudIcon from "../../assets/icons/fraudImg.svg";
import helpImgsvg from "../../assets/icons/helpImg.svg";
import privacyIcon from "../../assets/icons/privacyimg.svg";
import reportIcon from "../../assets/icons/reportImg.svg";
import termsIcon from "../../assets/icons/termsImg.svg";
import seftyIcon from "../../assets/icons/seftyImg.svg";
import sections from "../../data/PrivacyPolicyData";
const PrivacypolicySection = () => {
  const [active, setActive] = useState("privacy");

  const currentSection = sections[active];

  return (
    <>
      <section className="privacy-policy-section">
        <Navbar/>
        <div className="privacy-page">
          {/* Sidebar */}
          <div className="sidebar">
            <h3>Safety</h3>
            <ul>
              <li
                className={active === "privacy" ? "active" : ""}
                onClick={() => setActive("privacy")}
              >
                <img src={privacyIcon} className="sidebarIcon"></img>Privacy
                Policy
              </li>

              <li
                className={active === "terms" ? "active" : ""}
                onClick={() => setActive("terms")}
              >
                <img src={termsIcon} className="sidebarIcon"></img>Terms &
                Conditions
              </li>

              <li
                className={active === "fraud" ? "active" : ""}
                onClick={() => setActive("fraud")}
              >
                <img src={fraudIcon} className="sidebarIcon"></img>Fraud Alert
              </li>

              <li
                className={active === "trust" ? "active" : ""}
                onClick={() => setActive("trust")}
              >
                <img src={seftyIcon} className="sidebarIcon"></img>Trust & Sefty
              </li>

              <li
                className={active === "report" ? "active" : ""}
                onClick={() => setActive("report")}
              >
                <img src={reportIcon} className="sidebarIcon"></img>Report Issue
              </li>

              <li
                className={active === "help" ? "active" : ""}
                onClick={() => setActive("help")}
              >
                <img src={helpImgsvg} className="sidebarIcon"></img>Help
              </li>
            </ul>
          </div>

          {/* Main content */}
          <div className="privacy-content">
            <div className="privacy-banner">
              <img
                src={currentSection.img}
                alt={currentSection.title}
                className={`banner-img ${active}-banner-img`}
              />
              <h1>{currentSection.title}</h1>
            </div>

            {/* Topics */}
            {currentSection.topics.map((topic, topicIndex) => (
              <div className="topic-section" key={topicIndex}>
                {topic.h && <h2>{topic.h}</h2>}

                {topic.content.map((item, itemIndex) => {
                  if (item.type === "text") {
                    // Simple string
                    if (typeof item.value === "string") {
                      return <p key={itemIndex}>{item.value}</p>;
                    }

                    // Text with links (array)
                    if (Array.isArray(item.value)) {
                      return (
                        <p key={itemIndex}>
                          {item.value.map((part, i) => {
                            if (typeof part === "string") {
                              return part;
                            }
                            if (part.type === "bold") {
                              return <strong key={i}>{part.text}</strong>;
                            }
                            if (part.type === "highlight") {
                              return (
                                <span key={i} className="highlight-text2">
                                  {part.text}
                                </span>
                              );
                            }

                            if (part.type === "link") {
                              return (
                                <a
                                  key={i}
                                  href={part.url}
                                  className="content-link"
                                >
                                  {part.text}
                                </a>
                              );
                            }

                            return null;
                          })}
                        </p>
                      );
                    }
                  }

                  if (item.type === "list") {
                    return (
                      <ul key={itemIndex}>
                        {item.value.map((li, liIndex) => (
                          <li key={liIndex}>
                            {/* Case 1: mixed content array (text + highlight) */}
                            {Array.isArray(li) &&
                              li.map((part, i) => {
                                if (typeof part === "string") return part;

                                if (part.type === "highlight") {
                                  return (
                                    <span key={i} className="highlight-text2">
                                      {part.text}
                                    </span>
                                  );
                                }

                                if (part.type === "link") {
                                  return (
                                    <a
                                      key={i}
                                      href={part.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="policy-link"
                                    >
                                      {part.text}
                                    </a>
                                  );
                                }

                                return null;
                              })}

                            {/* CASE 2: object with text + children */}
                            {!Array.isArray(li) &&
                              typeof li === "object" &&
                              li.text && (
                                <>
                                  {li.text}

                                  {li.children && (
                                    <ul>
                                      {li.children.map((child, cIndex) => (
                                        <li key={cIndex}>{child}</li>
                                      ))}
                                    </ul>
                                  )}
                                </>
                              )}

                            {/* Case 3: plain string */}
                            {!Array.isArray(li) && typeof li === "string" && li}
                          </li>
                        ))}
                      </ul>
                    );
                  }

                  if (item.type === "table") {
                    return (
                      <table key={itemIndex} className="info-table">
                        <thead>
                          <tr>
                            {item.value.headers.map((h, i) => (
                              <th key={i}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {item.value.rows.map((row, r) => (
                            <tr key={r}>
                              {row.map((cell, c) => (
                                <td key={c}>{cell}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    );
                  }

                  return null;
                })}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacypolicySection;